import {
  LIST_STATEMENTS,
} from '@/data/actions/modules/financial';

export default [
  {
    path: '/financial/statements',
    component: () => import(/* webpackChunkName: "statements" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_STATEMENTS,
    },
  },
];
